<template>
	<div>
		<form-input
			v-if="questions && questions.length > 0"
			:name="name"
			:questions="questions"
			:savedAnswers="savedAnswers"
			:inputAnswers="answers"
			:fileID="fileID"
			:receiveanswernumbers="receiveanswernumbers"
			@submitForm="sendCsrReport"
			@save="saveCsrReport"
			@updateAnswerNumbers="updateAnswerNumbers"
		/>
	</div>
</template>

<script>
import CSRApi from "../api/csr/csr"
//import router from "../router"
import LoadingState from "../consts/LoadingState"
import FormInput from "../components/FormInput.vue"
export default {
	name: "AuditInput",
	components: {
		"form-input": FormInput
	},
	data() {
		return {
			questions: null,
			name: "Audit",
			id: "2022",
			fileID: null,
			savedAnswers: [],
			answers: [],
			answernumbers: [],
			receiveanswernumbers:[]
		}
	},
	props: {
		preview: Boolean,
		previewID: Number
	},
	mounted() {
		this.loadAudit()

		/* if (this.preview == true) {
			this.loadPreview()
		} else if (isNaN(parseInt(this.$route.params.id))) {
			router.push("/")
		} else {
			this.id = parseInt(this.$route.params.id)
		} */
	},
	methods: {
		updateAnswerNumbers(newAnswerNumbers) {
			this.answernumbers = newAnswerNumbers
		},
		loadAudit() {
			CSRApi.getCSRForm()
				.then(data => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{
							root: true
						}
					)
					if (data.csrID) {
						return this.$router.push("/csr/submissions/"+data.csrID)
					}
					this.name = data.name
					this.id = data.id
					this.$set(this,"questions", data.questions)
					this.fileID = data.fileID

					this.savedAnswers = []
					for (let i = 0; i < this.questions.length; i++) {
						this.answers.push(null)
						this.savedAnswers.push(null)
					}

					// if (data.answers != "") {
					// 	this.answers = data.answers
					// 	this.savedAnswers = JSON.parse(JSON.stringify(data.answers))
					// }
					this.receiveanswernumbers = data.answernumbers
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		sendCsrReport(answers) {
			const answernumbersString = JSON.stringify(this.answernumbers)
			CSRApi.submitForm(this.id, answers, answernumbersString)
				.then(data => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully completed CSR Form with ID '${data}'`,
						{ root: true }
					)
					//TODO: push to right page
					this.$router.push(`/csr/submissions/${data}`)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		saveCsrReport(answers) {
			const answernumbersString = JSON.stringify(this.answernumbers)
			CSRApi.saveSubmission(this.id, answers ,answernumbersString)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully saved CSR Submission draft!`,
						{ root: true }
					)
					this.savedAnswers = JSON.parse(JSON.stringify(answers))
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		}
	}
}
</script>
